module.exports = __webpack_public_path__ + "img/pointer.1d41ab15.png";